import { z } from 'zod';

export const updateProfileResponseSchema = z.object({
  success: z.boolean(), // Indica il successo dell'operazione
  message: z.string().optional(), // Messaggio opzionale
  error: z.string().optional(), // Messaggio di errore, se presente
});

export type UpdateProfileResponse = z.infer<typeof updateProfileResponseSchema>;

export const sendSsoCredentialResponseSchema = z.object({
  success: z.boolean(), // Indica il successo dell'operazione
  message: z.string().optional(), // Messaggio opzionale
  error: z.string().optional(), // Messaggio di errore, se presente
});

export type SendSsoCredentialResponse = z.infer<typeof sendSsoCredentialResponseSchema>;
